module.exports = __webpack_public_path__ + "img/symbol_5.edd6bbe6.png";